var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-upload-image" },
    [
      _c(
        "div",
        [
          _c(
            "el-upload",
            {
              class: { hide: this.fileList.length >= this.limit },
              attrs: {
                action: _vm.uploadImgUrl,
                "list-type": "picture-card",
                "on-success": _vm.handleUploadSuccess,
                "before-upload": _vm.handleBeforeUpload,
                limit: _vm.limit,
                "on-error": _vm.handleUploadError,
                "on-exceed": _vm.handleExceed,
                name: "file",
                "on-remove": _vm.handleRemove,
                "show-file-list": true,
                headers: _vm.headers,
                "file-list": _vm.fileList,
                "on-preview": _vm.handlePictureCardPreview,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "showText" }, [
            _vm._v(_vm._s(_vm.showText)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "预览",
            width: "800",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: {
              display: "block",
              "max-width": "100%",
              margin: "0 auto",
            },
            attrs: { alt: "图片", src: _vm.dialogImageUrl },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }